<template>
    <el-drawer
        :title="id ? '编辑渠道' : '新增渠道'"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content" v-loading="dataLoading">
            <el-form
                :model="formData"
                :rules="rules"
                ref="formData"
                label-position="top"
                size="medium"
            >
                <el-form-item prop="channelName" label="渠道名称:">
                    <el-input
                        v-model="formData.channelName"
                        placeholder="请填写渠道名称"
                        :maxlength="40"
                    ></el-input>
                </el-form-item>
                <el-form-item prop="trackPath" label="跟踪参数:">
                    <el-input
                        v-model="formData.trackPath"
                        placeholder="请填写跟踪参数"
                        :maxlength="40"
                        :disabled="formData.id ? true : false"
                    ></el-input>
                    <small class="MT10">
                        建议渠道名字和位置用-分隔，比如：
                        <div>网易云banner=wy-banner，百度音乐人推荐演出=bdyyr-tjyc，小酒馆微信=xjg-wx，小酒馆豆瓣=xjg-db</div>
                    </small>
                </el-form-item>
                <el-form-item prop="remark" label="备注:">
                    <el-input
                        show-word-limit
                        type="textarea"
                        v-model="formData.remark"
                        placeholder="请填写备注"
                        :maxlength="100"
                        :rows="2"
                    ></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading">确 定</el-button>
        </div>
    </el-drawer>
</template>
<script>
const defaultFormData = {
    channelName: "",
    id:"",
    remark: "",
    trackPath: ""
}
export default {
    data(){
        return{
            drawerShow:false,
            btnLoading:false,
            dataLoading:false,
            formData:{...defaultFormData},
            rules:{
                channelName: [{ required: true, message: "请填写渠道名称" }],
                trackPath: [{ required: true, message: "请填写跟踪参数" }],
            },
            id:""
        }
    },
    methods:{
        show(id){
            this.id = id || '';
            if( this.id ){
                this.getDataDetails();
            }
            this.drawerShow = true;
        },
        close(){
            this.formData = {...defaultFormData};
            this.$refs.formData && this.$refs.formData.resetFields();
            this.drawerShow = false;
        },
        //获取详情
        getDataDetails(){
            this.dataLoading = true;
            this.$request({
                url: '/report/channel/getChannel',
                params: {id: this.id},
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.formData = {
                            ...this.formData,
                            ...result
                        }
                    } else {
                        this.$message.error(msg || "获取详情失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取详情失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
         //表单提交
        submitForm(){
            this.$refs["formData"].validate( (valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.$request({
                        url: '/report/channel/channelEdit',
                        data: {...this.formData},
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$emit('onUpdate');
                                this.close();
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                }
            })
        }
    }
}
</script>